import { useState } from "react";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { Cursor } from "@/components/site/Cursor";
import { Loader } from "@/components/site/Loader";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { Equipment } from "@/components/site/Equipment";
import { Coverage } from "@/components/site/Coverage";
import { Showcase } from "@/components/site/Showcase";
import { Franchise } from "@/components/site/Franchise";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  const [started, setStarted] = useState(false);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App grain" data-testid="app-root">
        <Cursor />
        <Loader onDone={() => setStarted(true)} />
        <Toaster
          position="bottom-center"
          theme="dark"
          toastOptions={{ style: { fontFamily: "JetBrains Mono, monospace" } }}
        />
        <Navbar />
        <main>
          <Hero start={started} />
          <EditorialMarquee />
          <Manifesto />
          <Services />
          <Equipment />
          <Coverage />
          <Showcase />
          <Franchise />
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    </ReactLenis>
  );
}
